// Tiptap's default empty document serializes to <p></p>. Some Tiptap configurations also produce
// <p><br></p> after explicit clearing. Treat both, plus whitespace-only HTML, as "empty" for
// required-field validation.
const EMPTY_PATTERNS = new Set(['', '<p></p>', '<p><br></p>', '<p><br/></p>', '<p><br /></p>']);

// Tags that count as content on their own even when no text is present (an image-only
// document is still meaningful and should not show "None" in read-only mode).
const CONTENT_TAGS = /<(?:img|table|hr)\b/i;

export const isEmptyTiptapHtml = (html: string | undefined | null): boolean => {
  if (!html) {
    return true;
  }

  const trimmed = html.trim();
  if (EMPTY_PATTERNS.has(trimmed)) {
    return true;
  }

  if (CONTENT_TAGS.test(trimmed)) {
    return false;
  }

  return (
    trimmed
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ')
      .trim().length === 0
  );
};
